import React from "react";
import "./About.css";
import Navbar from "../Navbar/Navbar";
import { FaFacebook, FaLinkedin, FaTwitter } from "react-icons/fa";
import Footer from "../Footer/Footer";
import p1 from '../Images/p1.jpg'
import p2 from '../Images/p2.png'
import p3 from '../Images/p3.jpg'
import p4 from '../Images/p4.jpg'
import bg1 from '../Images/bg1.jpeg'

const AboutUs = () => {
  return (
    <>
      <Navbar />

      <div className="about-page">
        {/* Hero / Breadcrumb */}
        <section className="about-hero">
          <div className="container">
            <h1>About Us</h1>
            <p>
              <a href="/">Home</a> / About Us
            </p>
          </div>
        </section>

        {/* Mission */}
        <section className="about-section">
          <div className="container">
            <h2>Our mission is clear</h2>
            {/* <p>
            Our team of consultants and design engineers specialize in the
            design of IBMS, AV, ELV, SECURITY, and ACOUSTICS, having many
            years of hands-on experience in these domains. Established in the
            year 2007, our founder has 40+ years of experience in the GCC
            market, while our other senior associates bring in a wealth of
            professional experience (15 to 20 years), creating an accumulated
            150+ years of collective experience to the firm.
          </p>
          <p>
            With an exceptional track record of having worked with international
            brands like Marriott, Accor, Hilton, Hyatt, Kempinski, Pullman,
            Starwood, Meraas, Musanada, Dubai Properties, Al Dar, Majed Al
            Futtaim, Amity, Landmark, Masdar, etc., our infrastructure domain
            knowledge is Best-in-Class, encompassing Hospitality, Governmental,
            Corporate / Enterprise, Educational, Residential and Sports /
            Stadiums sectors.
          </p> */}
            <p>
              Our team of consultants and design engineers specializes in the design of integrated ELV systems,
              encompassing Acoustics, Security, SRA, IT/ICT, IBMS, AV, Sustainability & Green Building, Project Management and supported by many years of hands-on experience across these domains.
            We deliver dedicated expertise, ensuring performance-driven and compliant design solutions.
            </p>
          </div>
        </section>

        {/* Company Background */}
        {/* <section className="about-section gray">
        <div className="container">
          <h2>Company Background</h2>
          <p>
            Established in 2007, INFOSIGHT designed and managed: 300+ Projects
            <br />
            <ul>
            
            <li> 150+ Hotels,</li>
            <li> 20+ Government Corporate Projects, 10+ Retails,  </li>
            <li> 2 Stadiums,  </li>
           <li>  4 Educational,  </li>
            <li> 4 Hospitals  </li>
            <li> Clinics,  </li>
           <li>  1 Data Centre, 100+ </li>
            <li> Residential  </li>
            <li> Mixed Use,  </li>
           <li>  3 Mosque Projects, </li>
            <li> Emaar Hotel Projects, </li>
           <li>  Large Data Centre Project (Airline - Dubai). </li>
            </ul>
          </p>
          <p>
            Infosight have worked with Al Dar Abu Dhabi to study flight path
            noise impact for their Yas island golf course residential project.
          </p>
          <p>
            In addition, we completed MAF (Majed Al Futtaim) for their multiple
            city Centre & VOX cinema warm shell design projects.
          </p>
          <p>
            We assure you that our AV specialist designers hold Infocomm’s CTS
            certification along with other industry credentials and completed a
            HEALTHCARE IT, AV, ICT & SECURITY design of a large multi-specialty
            500 Bed-Hospital Project in Tirupati, Andhra Pradesh, India.
          </p>
          <p>
            Most of the senior consultants have migrated from a System
            Integration background with rich project execution experience and
            now specialize on design consultancy and project management.
          </p>
        </div>
      </section> */}

        {/* Company Background */}
        <section className="about-section gray">
          <div className="container">
            <h2>Company Background</h2>

            {/* <p>
      Infosight brings extensive experience in delivering complex design studies
      and consultancy services for large-scale, master-planned developments,
      including environmental and operational impact assessments for
      noise-sensitive residential and mixed-use environments.
    </p>

    <p>
      Our portfolio spans retail, entertainment, commercial, healthcare, and
      public-sector developments, where we deliver coordinated, tenant-ready,
      and future-focused design solutions across diverse asset classes.
    </p>

    <p>
      Our consulting teams comprise certified and decorated specialists with
      proven expertise in delivering integrated technology, infrastructure, and
      building systems design solutions aligned with stringent operational,
      compliance, and performance requirements.
    </p>

    <p>
      A significant proportion of our senior consultants bring strong system
      integration and project execution backgrounds, strengthening our design
      consultancy and project management services with practical,
      implementation-ready insights.
    </p> */}
            <p>

              Established in 2007, the firm is led by a founder with over 40 years of experience in the GCC market.
              Our senior associates contribute an additional 15–20 years of domain expertise each,
              bringing together more than 150 years of cumulative professional experience within the organization.
            </p>

            <p>
              With a strong track record of collaboration with renowned international brands such as
              Marriott, Accor, Hilton, Hyatt, Kempinski, Pullman, Starwood, Meraas, Musanada, Dubai Properties, Aldar, Majid Al Futtaim, Amity, Landmark,
              and Masdar, we offer best-in-class infrastructure domain knowledge.
              Our experience spans Hospitality, Government, Corporate and Enterprise, Education, Residential, and Sports and Stadium developments.
            </p>
          </div>
        </section>


        {/* Experience Highlights */}
        <section className="about-highlights">
          <div className="container highlights">
            <div className="highlight-box">
              <h3>20+</h3>
              <p>Years' Experience</p>
            </div>
            <div className="highlight-box">
              <h3>500+</h3>
              <p>Projects Delivered</p>
            </div>
          </div>
        </section>

        {/* Management */}
        <section className="about-section">
          <div className="container">
            <h2>Our Management</h2>

            <div className="management">
              <div className="manager">
                <div className="manager-img">
                  <img src={p1} alt="K S N Prasad" className="manager-image" />
                </div>
                <h3>K S N Prasad</h3>
                <p>Managing Director</p>
                <p>
                  Mr. Prasad has more than 3 decades of rich and varied experience
                  in the field of IT infrastructure, low-current systems, ICT, AV,
                  and various ELV systems...
                </p>
              </div>

              {/* <div className="manager">
               <div className="manager-img">
        <img src={p2} alt="Vamsidhar Babu Komatineni" className="manager-image1" />
        </div>
        <h3>Vamsidhar Babu Komatineni</h3>
        <p>Managing Director - India</p>
        <p>
          Mr. Vamsidhar is a highly accomplished professional with over 36
          years of diverse experience spanning manufacturing, consultancy,
          real estate, and training...
        </p>
      </div> */}
              <div className="manager">
                <div className="manager-bg1">
                  <div className="manager-img1">
                    <img
                      src={p2}
                      alt="Vamsidhar Babu Komatineni"
                      className="manager-image1"
                    />
                  </div>
                </div>

                <h3 style={{ marginTop: '50px' }}>Vamsidhar Babu Komatineni</h3>
                <p>Managing Director - India</p>
                <p>
                  Mr. Vamsidhar is a highly accomplished professional with over 36 years of
                  diverse experience spanning manufacturing, consultancy, real estate, and
                  training...
                </p>
              </div>

              <div className="manager">
                <div className="manager-img">
                  <img src={p3} alt="Suresh Kumar G" className="manager-image" />
                </div>
                <h3>Suresh Kumar G</h3>
                <p>Executive Director</p>
                <p>
                  Mr. Suresh Kumar has over 27 years of experience in the field of
                  technology and more than 17 years of consulting experience in
                  the IT/AV/security/ELV fields...
                </p>
              </div>

              <div className="manager">
                <div className="manager-img">
                  <img src={p4} alt="Roshan M Thomas" className="manager-image" />
                </div>
                <h3>Roshan M Thomas</h3>
                <p>Principal Consultant</p>
                <p>
                  An Instrumentation & Electronics Engineer, with professional
                  experience for the past twelve years in the field of security
                  consulting and management...
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>


      <Footer />
    </>
  );
};

export default AboutUs;
